export default "__VITE_ASSET__D_Iofnjv__"